import React from 'react';

/*
  The Batchtrue mark: a capital B whose two counters are chromatogram peaks.

  Construction. The stem and outer silhouette are a conventional grotesque B, so
  the letter reads first. Both counters are then cut as bell curves rather than
  the usual rounded voids: flat along the stem where a peak sits on its baseline,
  then tapering right to a resolved apex. The two peaks are deliberately unequal,
  a minor above and a dominant below, which is how an actual lot reads.

  It is drawn as a single even-odd path so it fills with currentColor and works
  reversed, in the reference rust, or as a favicon. Verified legible at 16px.
*/

const MARK_PATH =
  'M11 8 H32.5 C41.6 8 47.6 12.9 47.6 19.8 C47.6 24.3 45.1 27.9 41.2 29.7 ' +
  'C45.8 31.2 49.6 35.3 49.6 41 C49.6 49.1 43.1 54 33.4 54 H11 Z ' +
  'M19 26.2 C27 26.2 31.2 24.7 38.2 20.6 C31.2 16.5 27 15 19 15 Z ' +
  'M19 47.2 C29 47.2 34.2 45.2 43.4 39.8 C34.2 34.4 29 32.4 19 32.4 Z';

export default function BatchtrueMark({ className = 'h-10 w-10', title }) {
  return (
    <svg
      className={className}
      viewBox="0 0 64 64"
      role={title ? 'img' : undefined}
      aria-label={title || undefined}
      aria-hidden={title ? undefined : true}
    >
      <path fillRule="evenodd" d={MARK_PATH} fill="currentColor" />
    </svg>
  );
}

/**
 * Mark plus wordmark. `tag` renders the subordinate line, usually "Wholesale".
 */
export function BatchtrueLockup({ className = '', markClassName = 'h-8 w-8', tag = 'Wholesale' }) {
  return (
    <span className={`flex items-center gap-2.5 ${className}`}>
      <BatchtrueMark className={`${markClassName} shrink-0`} />
      <span className="flex flex-col leading-none">
        <span className="text-[0.98rem] font-semibold tracking-[-0.012em]">Batchtrue</span>
        {tag ? <span className="label-quiet mt-[0.18rem]">{tag}</span> : null}
      </span>
    </span>
  );
}

export { MARK_PATH };
